import Pagination, { PaginationProps } from "@insite/mobius/Pagination";
import { GalleryPaginationModel } from "@store/Widgets/ImageGallery/ImageGalleryStore";
import React, { ChangeEvent } from "react";

interface OwnProps {
    pagination: any;
    setParameter: (parameter: any) => void;
    parameter: GalleryPaginationModel;
}

export interface PaginationStyles {
    pagination?: PaginationProps;
}

const paginationStyles: PaginationStyles = {};

const styles = paginationStyles;

const PaginationImageGallery = ({ pagination, setParameter, parameter }: OwnProps) => {
    const changePage = (newPageIndex: number) => {
        setParameter({ ...parameter, page: newPageIndex });
    };

    const changeResultsPerPage = (event: ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        setParameter({ page: 1, pageSize: newPageSize });
    };

    if (!pagination || pagination.totalItemCount === 0) {
        return null;
    }

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={pagination.totalItemCount}
            currentPage={pagination.currentPage}
            resultsPerPage={pagination.pageSize}
            resultsPerPageOptions={pagination.pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
        />
    );
};

export default PaginationImageGallery;
